import { FormInputRow } from 'components/input';
import React from 'react';
import AssignedCrystals from './assignedCrystals';
import {
  getSynchTripInputFields,
  GetSynchTripInputFieldsParams,
  SynchTripInputs,
} from './utils';
import { SynchTripDataDTO } from './constants';
import ETreeNodeAccessRightNames from 'enums/ETreeNodeAccessRightNames';

interface Props {
  synchTrip?: SynchTripDataDTO;
  handleInputChange?: (e: any) => void;
  handleCollected?: (id: number) => void;
  unassignCrystal?: (ids: number[]) => void;
  refetchSynchTrip?: () => void;
}

const SynchrotronTripForm = (props: Props) => {
  const {
    synchTrip,
    handleInputChange,
    handleCollected,
    unassignCrystal,
    refetchSynchTrip,
  } = props;

  const synchTripInputFieldsParams: GetSynchTripInputFieldsParams = {
    synchTrip: synchTrip,
    handleInputChange: handleInputChange,
  };

  const SynchTripInputFields: SynchTripInputs[] = getSynchTripInputFields(
    synchTripInputFieldsParams,
  );

  const isReadOnly = synchTrip.accessRightName !== ETreeNodeAccessRightNames.Modify;

  return (
    <div id="synchrotron-tripform-wrapper" className="h-[100%]">
      <h4 id="synchrotron-tripform-title" className="h-[4.45%]">
        Synchrotron Trip Info
      </h4>
      <form id="syncrotron-tripform-form" className="h-[36.6%]">
        <div
          id="syncrotron-tripform-form-synchtripinput"
          className="flex flex-col flex-wrap max-h-44"
        >
          {SynchTripInputFields.map((f, index) => (
            <div
              id="syncrotron-tripform-form-synchtripinput-forminputrow"
              key={index}
              className="w-1/2"
            >
              <FormInputRow
                key={f.name}
                labeltext={f.label}
                id={f.name}
                name={f.name}
                type={f.type}
                value={f.value}
                onChange={f.onChange}
                disabled={f.isDisabled}
                labelClassname="w-2/5 text-sm self-end"
                inputClassname="w-3/5"
                containerClassname="m-1"
                readOnly={isReadOnly}
              />
            </div>
          ))}
        </div>
        <div
          id="syncrotron-tripform-notes-wrapper"
          className="flex flex-row mt-1 justify-between px-1 w-full"
        >
          <span id="syncrotron-tripform-notes-label" className="w-[15%] text-sm">
            <label id="syncrotron-tripform-notes-label-text" htmlFor="notes">
              Notes
            </label>
          </span>
          <span id="syncrotron-tripform-notes-textarea-section" className="w-[85%]">
            <textarea
              name="notes"
              id="syncrotron-tripform-notes-textarea"
              value={synchTrip?.notes}
              className="w-full selection:bg-blue-500 selection:text-white focus:outline-none"
              rows={3}
              onChange={handleInputChange}
              readOnly={isReadOnly}
            ></textarea>
          </span>
        </div>
      </form>
      {synchTrip?.assignedCrystals && (
        <div id="syncrotron-tripform-assigned-crystals" className="mt-3 h-[55.7%]">
          <AssignedCrystals
            crystals={synchTrip?.assignedCrystals}
            handleCollected={handleCollected}
            unassignCrysal={unassignCrystal}
            refetchSynchTrip={refetchSynchTrip}
            isReadOnly={isReadOnly}
          />
        </div>
      )}
    </div>
  );
};

export default SynchrotronTripForm;
